exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fixed-collapse:has(button.hide-text){\n  width: 0;\n}\n", ""]);

// exports
